import React from 'react';

export default () => (
  <main className='not-found-scene'>
    <section>404</section>
    <section>
      PAGE
      <br />
      NOT FOUND
    </section>
  </main>
);



// WEBPACK FOOTER //
// ./src/app/Scenes/NotFoundScene/index.jsx